import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	margin-top: 30px;
`;

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

const StyledSettingsItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledSettingsItemTitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPanelControlsContainer = styled.div`
	margin-top: 40px;
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	margin-top: 40px;
`;

const StyledHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledWheelSizeContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
`;

const StyledWheelSettingsItem = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 50px;
	padding: 10px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255,255,255,0.1)'};
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	div {
		${Text} {
			color: #ffffff;
			transition: color 0.3s ease;

			&:nth-child(1) {
				font-size: 12px;
				opacity: 0.25;
			}

			&:nth-child(2) {
				font-weight: 500;
				font-size: 14px;
			}
		}
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		div {
			${Text} {
				color: #000000;
			}
		}
	}
`;

const StyledButtonContainer = styled.div`
	margin-top: 30px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	img {
		width: 11px;
	}
`;

const StyledResetButton = styled.button`
	width: 65px;
	height: 20px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	color: #fff;
	font-family: GT Walsheim Pro;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	border: none;
	cursor: pointer;
	user-select: none;

	transition: all 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

export {
	StyledButtonContainer,
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledHeadingContainer,
	StyledPanelControlsContainer,
	StyledResetButton,
	StyledSettingsContainer,
	StyledSettingsItemContainer,
	StyledSettingsItemTitleContainer,
	StyledWheelSettingsItem,
	StyledWheelSizeContainer,
};
